import { render, staticRenderFns } from "./CreateChannel.vue?vue&type=template&id=13a234c6&"
import script from "./CreateChannel.vue?vue&type=script&lang=js&"
export * from "./CreateChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports